import { Modal, Button } from '../../ui';

interface LayoutPromptModalProps {
  isOpen: boolean;
  onClose: () => void;
  onLayoutOnly: () => void;
  onFullFlow: () => void;
}

/**
 * Modal para escolher entre exportar apenas layouts ou fazer fluxo completo
 * Aparece quando o item já possui arquivos de impressão
 * 
 * ✅ MIGRADO: Usa componente Modal base para remover código duplicado
 */
export function LayoutPromptModal({ 
  isOpen, 
  onClose, 
  onLayoutOnly, 
  onFullFlow 
}: LayoutPromptModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      title="Exportar Layouts (PNG)"
      onClose={onClose}
      size="sm"
    >
      <div className="space-y-3">
        <p className="text-gray-300 text-xs">
          Este item já possui arquivos de impressão. Deseja exportar apenas os layouts (PNG) agora, ou refazer o fluxo completo?
        </p>
        <div className="flex justify-end gap-2">
          <Button 
            variant="secondary" 
            size="xs" 
            onClick={onClose}
            className="px-3 py-1.5"
          >
            Cancelar
          </Button>
          <Button 
            variant="warning" 
            size="xs" 
            onClick={onLayoutOnly}
            className="px-3 py-1.5"
          >
            Apenas PNG
          </Button>
          <Button 
            variant="primary" 
            size="xs" 
            onClick={onFullFlow}
            className="px-3 py-1.5 bg-purple-500 hover:bg-purple-600"
          >
            Fluxo Completo
          </Button>
        </div>
      </div>
    </Modal>
  );
}

